/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import {
	SterilizationParameters,
} from "../emptySterilization.types";

interface Props {
	sterilizationParameters: SterilizationParameters;
	toggleConfirmationModal: () => void;
	totalContainers: number;
}

const ESFooter = ({
	sterilizationParameters,
	toggleConfirmationModal,
	totalContainers,
}: Props) => {

	const { t } = useTranslation();
	console.log("Sterilization Parameters:", sterilizationParameters);
	console.log("Total Containers:", totalContainers);
	return (
		<div className="fixed bottom-0 left-64 right-0 bg-white px-10 py-6 border-t border-slate-200 flex justify-end items-center shrink-0 shadow-[0_-4px_20px_rgba(0,0,0,0.03)]">
			<button
				onClick={toggleConfirmationModal}
				className="px-12 py-4 bg-[#2D3E50] text-white rounded-2xl text-[11px] font-black uppercase tracking-widest shadow-xl shadow-slate-200 hover:bg-slate-800 transition-all flex items-center gap-2.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#2D3E50]"
			>
				{t("postAutoclaveProcess.emptySterilization.confirmSterilization")}
				<span className="material-symbols-outlined text-lg">
					arrow_forward
				</span>
			</button>
		</div>
	);
};

export default ESFooter;
